import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"
import SignaturePad from 'signature_pad'

export default class extends Controller {
  static targets = ["canvas", "output"]

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: 'rgb(255, 255, 255)',
      penColor: 'rgb(0, 0, 0)',
      minWidth: 1,
      maxWidth: 2.5
    })

    // Set canvas size
    this.resizeCanvas()
    window.addEventListener('resize', this.resizeCanvas.bind(this))
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeCanvas.bind(this))
  }

  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const canvas = this.canvasTarget

    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext("2d").scale(ratio, ratio)

    this.signaturePad.clear() // Clear on resize to avoid artifacts
  }

  clear(event) {
    event.preventDefault()
    this.signaturePad.clear()
    this.outputTarget.value = ''
  }

  save(event) {
    if (this.signaturePad.isEmpty()) {
      event.preventDefault()
      alert(t('javascript.controllers.signature_pad_controller.please_provide_a_signature_first'))
      return false
    }

    // Get signature as base64 data URL
    const dataURL = this.signaturePad.toDataURL()
    this.outputTarget.value = dataURL
    return true
  }

  decline(event) {
    event.preventDefault()

    const reason = document.querySelector('[name="decline_reason"]').value
    if (!reason || reason.trim() === '') {
      alert(t('javascript.controllers.signature_pad_controller.please_provide_a_reason_for_declining'))
      return
    }

    if (!confirm(t('javascript.controllers.signature_pad_controller.confirm_decline'))) {
      return
    }

    // Submit decline form
    const form = this.element.closest('form')
    const declineUrl = form.action.replace('/sign', '/decline')

    fetch(declineUrl, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ decline_reason: reason })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        window.location.href = data.redirect || '/document_signatures'
      } else {
        alert(data.error || t('javascript.controllers.signature_pad_controller.failed_to_decline_document'))
      }
    })
    .catch(error => {
      console.error('Error declining:', error)
      alert(t('javascript.controllers.signature_pad_controller.an_error_occurred_please_try_again'))
    })
  }
}
